<template>
  <v-row no-gutters ref="widget">
    <v-col cols="12" sm="6">
      <amount-sheet :readonly="true" />
    </v-col>
    <v-col cols="12" sm="6">
      <v-sheet class="my-3 overflow-hidden" rounded outlined>
        <v-card-text>
          <v-row align="center" no-gutters>
            <v-col cols="8">
              <v-btn class="ml-1" @click="$router.push({ name: 'PaymentLink', params: { pk: $route.params.pk } })" color="primary" :ripple="false" text><v-icon left>mdi-arrow-left</v-icon>Volver</v-btn>
            </v-col>
            <v-col class="text-right" cols="4">
              <img :src="require(`@/assets/appAsset-brand--webpay.svg`)" alt="webpay" height="28">
            </v-col>
          </v-row>
          <v-row align="center" justify="start">
            <v-col cols="12" class="py-6 text-center">
              <v-progress-circular indeterminate :color="instance.account.color_background" />
              <span class="d-block mt-2 text--secondary font-weight-medium">Redireccionando a WebPay</span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-text class="background">
          <v-row align="center" justify="start" no-gutters>
            <v-col cols="12">
              <v-btn :style="{'background-color': `${instance.account.color_background} !important`}" :loading="loaderMain" height="40" block dark>
                <template v-if="instance.cta === 'pay'">Pagar</template>
                <template v-else-if="instance.cta === 'donate'">Donar</template>
                <template v-else-if="instance.cta === 'book'">Reservar</template>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <span class="d-block mt-4 body-2 text--primary">Pago procesado de forma segura a través de Webpay</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-sheet>
      <piriod-sign text="cobra con los enlaces de pago de" />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'

import AmountSheet from '../../components/payment-links/AmountSheet'
import PiriodSign from '../../components/base/PiriodSign'

import GenericViewMixin from '../../mixins/GenericViewMixin'
import WidgetViewMixin from '../../mixins/WidgetViewMixin'

export default {
  name: 'piriod-gateway-webpay',
  mixins: [
    GenericViewMixin,
    WidgetViewMixin
  ],
  components: {
    AmountSheet,
    PiriodSign
  },
  data: () => ({
    loaderMain: true
  }),
  computed: mapState({
    amount: state => state.paymentLinks.linksAmount,
    customer: state => state.paymentLinks.intentCustomer,
    instance: state => state.paymentLinks.linksDetail,
    intent: state => state.paymentLinks.intentsDetail
  }),
  created () {
    // wait for the next tick to perform payment
    this.$nextTick(() => {
      this.pay()
    })
  },
  methods: {
    pay () {
      this.loaderMain = true

      const payload = {
        customer: this.customer,
        gateway: 'webpay',
        link: this.$route.params.pk,
        return_url: this.referrerUrl
      }

      // set custom amount from store if
      // amount_scheme is custom
      if (this.instance.amount_scheme === 'custom') {
        payload.amount = this.amount
      }

      // perform payment
      this.$store.dispatch('paymentLinks/CREATE', {
        resource: 'publishable/payment_links/intents',
        payload: payload
      })
      .then(() => {
        if (this.intent.status === 'pending') {
          const authorizeUrl = `${this.$API_BASE}/publishable/payment_links` +
                               `/intents/${this.intent.publishable_key}/authorize/`

          this.onRedirect(authorizeUrl)
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        this.loaderMain = false
      })
    }
  }
}
</script>